import { render } from "./InlineLink.vue?vue&type=template&id=38f0e6f5&scoped=true"
import script from "./InlineLink.vue?vue&type=script&lang=js"
export * from "./InlineLink.vue?vue&type=script&lang=js"

import "./InlineLink.vue?vue&type=style&index=0&id=38f0e6f5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f0e6f5"]])

export default __exports__